<template>
  <label class="base-input" for="email">
    <input
      :value="modelValue"
      class="base-input__input"
      :class="{
        'base-input__input-error': error,
        'base-input__input-icon': iconName,
        'base-input__input-disabled': disabled,
      }"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      @focus="emits('on-focus')"
      @blur="emits('on-blur')"
    >
    <nuxt-icon
      v-if="iconName"
      :name="iconName"
      class="base-input__icon"
    />
  </label>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  type: {
    type: String,
    default: 'email',
  },
  iconName: {
    type: String,
  },
  error: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:modelValue', 'on-focus', 'on-blur']);

function onInput({ target }: Event): void {
  emits('update:modelValue', (target as HTMLInputElement).value);
}
</script>

<style lang="scss" scoped>
.base-input {
  position: relative;
  display: block;
  text-align: center;
  margin: 0 auto;
  width: 100%;

  &__icon {
    position: absolute;
    top: 8px;
    right: 20px;
    font-size: 32px;
    color: $text-color;
  }

  &__input {
    background: $gray-bg;
    border-radius: 9px;
    font-size: 16px;
    padding: 14px 20px;
    width: 100%;
    position: relative;
    border: 2px solid transparent;
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    appearance: none;
    transition-duration: .15s;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.04) inset;
    height: 53px;

    &:focus, &:active {
      outline: none;
    }
  }

  &__input-error {
    color: $red !important;
    border: 2px solid $red;
  }

  &__input-icon {
    padding-right: 40px;
  }

  &__input-disabled {
    box-shadow: unset;
    background: #F9F9F9;
  }
}
</style>
